// @flow
import React from 'react';
import styled from 'styled-components';
import { ComboBoxInput, TextBlock } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';

import { annualStatusPresentation, annualStatusOptions } from './annualTaskCategories.config';
import type { YearlyData } from './types';

const FinancialPackageAnnualTasksLayout = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(5, 100px);
  grid-template-rows: 48px auto;
  grid-auto-flow: column;
`;

type FinancialPackageAnnualTasksProps = {
  onStatusChange: (string, string) => void,
  showNewYefStatuses: boolean,
  yearlyData: YearlyData,
};

const FinancialPackageAnnualTasks = ({
  onStatusChange,
  showNewYefStatuses,
  yearlyData,
}: FinancialPackageAnnualTasksProps) => {
  const {
    yearEndReview,
    cpaAdjustment,
    equityClosingAdjustment,
    trialBalanceOrPriorReturn,
    yearEndFinancialPackage,
  } = yearlyData;
  return (
    <FinancialPackageAnnualTasksLayout>
      <TextBlock color={colors.smoke} styleType="small">
        Trial Balance or Prior Tax Return
      </TextBlock>
      {trialBalanceOrPriorReturn ? (
        <TextBlock styleType="small">
          {annualStatusPresentation[trialBalanceOrPriorReturn]}
        </TextBlock>
      ) : (
        <TextBlock>&mdash;</TextBlock>
      )}
      <TextBlock color={colors.smoke} styleType="small">
        CPA Adjusting Journal Entries
      </TextBlock>
      {cpaAdjustment ? (
        <TextBlock styleType="small">{annualStatusPresentation[cpaAdjustment]} </TextBlock>
      ) : (
        <TextBlock>&mdash;</TextBlock>
      )}

      <TextBlock color={colors.smoke} styleType="small">
        Year End Equity Closing Adjustment
      </TextBlock>
      {equityClosingAdjustment ? (
        <TextBlock styleType="small">{annualStatusPresentation[equityClosingAdjustment]}</TextBlock>
      ) : (
        <TextBlock>&mdash;</TextBlock>
      )}

      <TextBlock color={colors.smoke} styleType="small">
        Year End Review (YER)
      </TextBlock>
      <ComboBoxInput
        value={{ label: annualStatusPresentation[yearEndReview], value: yearEndReview }}
        onChange={e => onStatusChange('yearEndReview', e.value)}
        options={annualStatusOptions.yearEndReview}
        size="small"
      />

      <TextBlock color={colors.smoke} styleType="small">
        Year End Financial Package (YEF)
      </TextBlock>
      <ComboBoxInput
        value={{
          label: annualStatusPresentation[yearEndFinancialPackage],
          value: yearEndFinancialPackage,
        }}
        onChange={e => onStatusChange('yearEndFinancialPackage', e.value)}
        options={annualStatusOptions.yearEndFinancialPackage.filter(
          option =>
            showNewYefStatuses ||
            (option.value !== 'CLIENT_REVIEWING' && option.value !== 'CLIENT_REQUESTED_ADJUSTMENT'),
        )}
        size="small"
      />
    </FinancialPackageAnnualTasksLayout>
  );
};

export default FinancialPackageAnnualTasks;
